export default function ({ route, redirect }) {
  console.log('redirect middleware', route, redirect)
  if (route.path === '/' && _.isEmpty(route?.query?.apiKey)) {
    return redirect({
      path: '/overview',
      query: route.query
    }) // Change this to your desired redirect URL
  }
  if (route.path === '/certifications' && _.isEmpty(route?.query?.apiKey)) {
    return redirect({
      path: '/compliance',
      query: route.query
    }) // Change this to your desired redirect URL
  }
}
